import { render, staticRenderFns } from "./confirmDeletionVkModal.vue?vue&type=template&id=64a606d4&"
import script from "./confirmDeletionVkModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionVkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports